export default "__VITE_ASSET__34225cb7__"